<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.5199 24.0011C30.5199 24.3811 30.3799 24.7611 30.0799 25.0611L24.0799 31.0611C23.4999
      31.6411 22.5399 31.6411 21.9599 31.0611C21.3799 30.4811 21.3799 29.5211 21.9599
      28.9411L26.8999 24.0011L21.9599 19.0611C21.3799 18.4811 21.3799 17.5211 21.9599
      16.9411C22.5399 16.3611 23.4999 16.3611 24.0799 16.9411L30.0799 22.9411C30.3799
      23.2411 30.5199 23.6211 30.5199 24.0011Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
    />
    <path
      d="M30.52 24C30.52 24.82 29.84 25.5 29.02 25.5H13.02C12.2 25.5 11.52 24.82 11.52
      24C11.52 23.18 12.2 22.5 13.02 22.5H29.02C29.86 22.5 30.52 23.18 30.52 24Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
    />
    <path
      d="M36.4603 23.9991C36.4603 28.2191 35.7803 32.4591 34.4403 36.4791C34.1803 37.2591 33.3203
      37.6791 32.5403 37.4191C31.7603 37.1591 31.3203 36.3191 31.6003 35.5191C34.0803 28.0791
      34.0803 19.8991 31.6003 12.4591C31.3403 11.6791 31.7603 10.8191 32.5403 10.5591C33.3203
      10.2991 34.1803 10.7191 34.4403 11.4991C35.8003 15.5391 36.4603 19.7791 36.4603 23.9991Z"
      :fill="color ? color : theme === 'light' ? '#292D32' : '#fff'"
    />
  </svg>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({ theme: 'getTheme' }),
  },
  data() {
    return {
      isHover: false,
    };
  },
  props: {
    color: {
      type: String,
    },
  },
};
</script>
